export default __webpack_public_path__ + "aeb1e939b60e3ecbedd0ec364f44fc95.png";